export default {"src":"/_next/static/image/src/assets/nav/logo-text.1c418082737af8389414cc32d2f8a2d0.svg","height":56,"width":281};